/* eslint-disable react/prop-types */
import React from 'react';

export const WithOptionDisabled = (WrappedComponent) => {
  return (props) => {
    const { options, field, form } = props;
    return (
      <WrappedComponent
        {...props}
        options={(options || []).map((option) => {
          const { shouldDisabled, ...rest } = option;
          return {
            ...rest,
            disabled: shouldDisabled ? shouldDisabled(option, { field, form }) : option.disabled,
          };
        })}
      />
    );
  };
};
